module.exports = __webpack_public_path__ + "static/media/producing_asset_3.a5de70b1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/producing_asset_3.jpg
// module id = 1855
// module chunks = 0